export default function checkCookieAvailability() {
  // Define a test cookie name and value
  const testCookieName = 'test_cookie';
  const testCookieValue = 'test_value';

  // Attempt to set the test cookie
  document.cookie = `${testCookieName}=${testCookieValue}; path=/`;

  // Try to read the test cookie
  const cookies = document.cookie;
  const cookieExists = cookies.includes(`${testCookieName}=${testCookieValue}`);

  // Clean up by deleting the test cookie
  document.cookie = `${testCookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;

  // Return the result
  return cookieExists;
}
